import { clampStyleToUnlocks, DEFAULT_STYLE, STARTER_UNLOCKS, validateStyle, type CharacterStyle } from './rpg.js';

/** Appearance defaults for the isolated race lobby and solo time trial. */
export const DEFAULT_RACE_STYLE: CharacterStyle = {
  ...DEFAULT_STYLE,
  auraColor: 3444735,
  pantsColor: 0x262c34,
};

/** Keep creator choices while restricting outfits to the shared starter wardrobe. */
export function normalizeRaceStyle(raw: unknown): CharacterStyle | null {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return null;
  // Validation constructs fresh bodyShape and hiddenGear values as well as the
  // outer object, so a room's accepted style never aliases the caller's data.
  const style = validateStyle(raw);
  return style ? clampStyleToUnlocks(style, new Set(STARTER_UNLOCKS)) : null;
}
